const HELLOFLEX_ROUTE_LINK_CLASS = 'helloflex-route-link';

export { HELLOFLEX_ROUTE_LINK_CLASS };
